import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ImprintPage = () => {
  return (
    <main className="main">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '2rem 0'
          }}
        >
          {/* Back Navigation */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            style={{ marginBottom: '2rem' }}
          >
            <Link 
              to="/" 
              style={{
                color: '#64ffda',
                textDecoration: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                transition: 'all 0.3s ease'
              }}
            >
              ← Back to Home
            </Link>
          </motion.div>

          {/* Page Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '3rem'
            }}
          >
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '800',
              background: 'linear-gradient(135deg, #64ffda 0%, #00ff88 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: '1rem'
            }}>
              Imprint
            </h1>
            <p style={{
              fontSize: '1.2rem',
              color: '#b0b0b0',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Legal information and contact details
            </p>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '20px',
              padding: '3rem',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)'
            }}
          >
            <div style={{
              color: '#e0e0e0',
              lineHeight: '1.6',
              fontSize: '1rem'
            }}>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '1.5rem',
                marginTop: '0'
              }}>
                Legal Information
              </h2>
              
              <h3 style={{
                color: '#00ff88',
                fontSize: '1.4rem',
                fontWeight: '600',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                Contact Information
              </h3>
              <p style={{ marginBottom: '1.5rem' }}>
                <strong>Responsible for content:</strong><br />
                Mathias Deppe<br />
                Video & Sales Strategist<br />
                Nemesi Valls 42<br />
                08210 Barbera del Valles<br />
                Spain
              </p>
              
              <p style={{ marginBottom: '2rem' }}>
                <strong>Contact:</strong><br />
                For business inquiries and contact information, please email us at:<br />
                <a 
                  href="mailto:contact@extraterrestrialtools.com"
                  style={{
                    color: '#64ffda',
                    textDecoration: 'none',
                    fontWeight: '600'
                  }}
                >
                  contact@extraterrestrialtools.com
                </a>
              </p>
              
              <h3 style={{
                color: '#00ff88',
                fontSize: '1.4rem',
                fontWeight: '600',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                Disclaimer
              </h3>
              
              <h4 style={{
                color: '#ffc107',
                fontSize: '1.2rem',
                fontWeight: '600',
                marginBottom: '0.8rem',
                marginTop: '1.5rem'
              }}>
                Liability for Content
              </h4>
              <p style={{ marginBottom: '1.5rem' }}>
                The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness, or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this matter, please note that we are not under obligation to supervise merely the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity.
              </p>
              
              <h4 style={{
                color: '#ffc107',
                fontSize: '1.2rem',
                fontWeight: '600',
                marginBottom: '0.8rem',
                marginTop: '1.5rem'
              }}>
                Liability for Links
              </h4>
              <p style={{ marginBottom: '1.5rem' }}>
                Our offer contains links to external third parties' web sites. We have no influence on the contents of those web sites, therefore we cannot guarantee for those contents. Providers or administrators of linked web sites are always responsible for their own contents. The linked web sites had been checked for possible violations of law at the time of the establishment of the link.
              </p>
              
              <h4 style={{
                color: '#ffc107',
                fontSize: '1.2rem',
                fontWeight: '600',
                marginBottom: '0.8rem',
                marginTop: '1.5rem'
              }}>
                Copyright
              </h4>
              <p style={{ marginBottom: '1.5rem' }}>
                Contents and compilations published on these web sites by the providers are subject to German copyright laws. Reproduction, editing, distribution as well as the use of any kind outside the scope of the copyright law require a written permission of the author or originator. Downloads and copies of these web sites are permitted for private use only.
              </p>
              
              <h4 style={{
                color: '#ffc107',
                fontSize: '1.2rem',
                fontWeight: '600',
                marginBottom: '0.8rem',
                marginTop: '1.5rem'
              }}>
                Affiliate Disclosure
              </h4>
              <p style={{ marginBottom: '1.5rem' }}>
                This website contains affiliate links. We earn from qualifying purchases. This means that if you click on one of our links and make a purchase, we may receive a small commission at no additional cost to you. This helps support our work and allows us to continue creating valuable content.
              </p>
              
              <h4 style={{
                color: '#ffc107',
                fontSize: '1.2rem',
                fontWeight: '600',
                marginBottom: '0.8rem',
                marginTop: '1.5rem'
              }}>
                Data Protection
              </h4>
              <p style={{ marginBottom: '2rem' }}>
                For information about how we collect, use, and protect your personal data, please refer to our <Link to="/privacy" style={{ color: '#64ffda', textDecoration: 'none', fontWeight: '600' }}>Privacy Policy</Link>.
              </p>
              
              <hr style={{
                border: 'none',
                height: '1px',
                background: 'linear-gradient(90deg, transparent, rgba(100, 255, 218, 0.3), transparent)',
                margin: '2rem 0'
              }} />
              
              <p style={{
                textAlign: 'center',
                color: '#64ffda',
                fontWeight: '600',
                fontSize: '0.9rem'
              }}>
                Copyright © Extraterrestrial Tools
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </main>
  );
};

export default ImprintPage;